<template>
  <b-card>
    <div slot="header">
      <h4 class="mr-5 pull-left">{{$t('USERS')}}</h4>
      <new-button :c_permission="C_USER_NEW_BUTTON"
                  @click="newUser"
                   button_type="new" variant="primary" class="pull-right">
          {{$t('NEW')}}
      </new-button>
    </div>
    <div class="table-responsive">
      <table class="table hover">
        <thead>
        <tr>
          <th>{{$t('FIRST_NAME')}}</th>
          <th>{{$t('LAST_NAME')}}</th>
          <th>{{$t('EMAIL')}}</th>
          <th>{{$t('ECONOMY')}}</th>
          <th>{{$t('INSTITUTION')}}</th>
          <th>{{$t('STATUS')}}</th>
          <th>{{$t('EDIT')}}</th>

        </tr>
        </thead>
        <tbody>
        <tr :key="index" v-for="(user,index) in userList">
          <td>{{user.first_name}}</td>
          <td>{{user.last_name}}</td>
          <td>{{user.email}}</td>
          <td>{{user.economy.name}}</td>
          <td>{{user.institution.name}}</td>
          <td>{{user.hasOwnProperty('is_active') && Number(user.is_active) === 1 ? $t('ACTIVE') : $t('NOTACTIVE') }}</td>
          <td>
             <user-edit-button
                   :c_permission="C_USER_EDIT_BUTTON"
                    @click="edit(user.id)">
             </user-edit-button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <b-pagination
      size="sm"
      :prev-text="$t('PREV')"
      :next-text="$t('NEXT')"
      :total-rows="listCount"
      :per-page="perPage"
      v-model="currentPage">
    </b-pagination>
    <user-aside  :state="userEditAsidePanelState" v-on:closeAside="closePanel">
      <user-edit-form v-if="formUpdateUser" @closePanel="closePanel" :userList="userList" :id="id"></user-edit-form>
      <user-new-form v-else-if="formNewUser" @closePanel="closePanel"></user-new-form>
    </user-aside>
  </b-card>
</template>

<script>
  import UserEditButton from '@/components/app/AppEdit'
  import UserAside from '@/components/app/AppAside'
  import NewButton from '@/components/app/AppButton'
  import UserEditForm from '@/components/user/UserEditForm'
  import UserNewForm from '@/components/user/UserNewForm'
  import {getUserList} from '@/services/user/index'
  import {C_USER_NEW_BUTTON} from "@/shared/component_permission"
  import {C_USER_EDIT_BUTTON} from '@/shared/component_permission'

  export default {
    name: "index",
    data(){
      return {
        fields: [
          {key: 'first_name', label: this.$t('FIRST_NAME')},
          {key: 'last_name', label: this.$t('LAST_NAME')},
          {key: 'email', label: this.$t('EMAIL')},
          {key: 'institution.name', label: this.$t('INSTITUTION')},
          {key: 'status', label: this.$t('STATUS')},
          {key: 'edit', label: this.$t('EDIT')}
        ],
        userEditAsidePanelState:false,
        formNewUser:false,
        formUpdateUser:false,
        id:null,
        C_USER_NEW_BUTTON,
        C_USER_EDIT_BUTTON
      }
    },
    components:{
      NewButton,
      UserAside,
      UserEditButton,
      UserEditForm,
      UserNewForm
    },
    computed:{
      filter() {
        return this.$store.getters['user/getSearchFilter']
      },
      currentPage: {
        get() {
          return this.filter.page
        },
        set(value) {
          this.$store.commit('user/setSearchFilterItem', {item: 'page', value})
          this.$store.dispatch('user/actionSearch')
        }
      },
      listCount(){
        return this.$store.getters['user/getSearchListCount']
      },
      userList(){
        return this.$store.getters['user/getSearchList']
      },
      perPage() {
        return this.filter.limit
      },
    },
    methods: {
      closePanel(){
        this.id = null
        this.userEditAsidePanelState = false
        this.formUpdateUser = false
        this.formNewUser = false

      },
      edit(id) {
        this.id = id
        this.userEditAsidePanelState = true
        this.formUpdateUser = true
      },
      newUser() {
        this.userEditAsidePanelState = true
        this.formNewUser = true
      },

    },
    created(){
      this.$store.dispatch('user/actionSearch')
    }
  }
</script>

<style scoped>

</style>
